import React from 'react';
import { PlaceholderListItem, PlaceholderSpan } from '../styles';

var PlaceholderItem = function PlaceholderItem(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(PlaceholderListItem, {
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(PlaceholderSpan, {
    "data-test": "pagination-placeholder"
  }, children));
};

PlaceholderItem.displayName = 'PlaceholderItem';
export default PlaceholderItem;